<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .general-crm-settings {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(16px);
  }

  .input-compact {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 570px;

    .dropdown-row {
      display: flex;
      align-items: center;
      background-color: colors.get(interfaceSwGrey_10);
      border-radius: utils.in_rem(10px);
      padding: utils.in_rem(2px);
    }

    .label {
      width: 240px;
      @include mixins.body2();
      padding: 0 utils.in_rem(14px);
    }

    color: colors.get(textBlack);
    @include mixins.body2();

    .select {
      width: utils.in_rem(300px);
    }
  }
</style>

<script>
  import Tooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/Tooltip.svelte";
  import SingleSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/SingleSelectDropdown/SingleSelectDropdown.svelte";
  import { integrationStore } from "../../../stores";

  // Get all note settings that are CRM-specific
  $: crmSpecificSettings = $integrationStore.getSettings("noteCreation");
</script>

{#if crmSpecificSettings.length > 0}
  <div class="general-crm-settings">
    {#each crmSpecificSettings as setting}
      {@const items =
        setting.values?.map((item) => ({
          id: item.val,
          value: item.val,
          label: item.key,
        })) || []}
      {@const getSelected = () => $integrationStore.getValue(setting.key)}
      {@const setSelected = (value) =>
        $integrationStore.setValue(setting.key, value)}

      <div class="input-compact">
        <div class="dropdown-row">
          <div class="label">
            <span>{setting.title}</span>
            {#if setting.description}
              <Tooltip text={setting.description} />
            {/if}
          </div>
          <div class="select">
            <SingleSelectDropdown
              style="width:300px;height:2.5rem;"
              size="large"
              {items}
              bind:selected={getSelected, setSelected}
              placeholder={`Select ${setting.title.toLowerCase()}`}
              showFilter={false}
              showDescription={true}
              restrictHeight={true}
            />
          </div>
        </div>
      </div>
    {/each}
  </div>
{/if}
